import apiClient from "apiClient";

export const getSurvey = (code, id) => {
  return apiClient
    .get(`/survey-api/api/feedback/${code}/${id}`)
    .then((response) => {
      return response.data;
    });
};

export const getSurveyWealth = (surveyId, id) => {
  return apiClient
    .get(`/survey-api/api/wealth/feedback/${surveyId}/${id}`)
    .then((response) => {
      return response.data;
    });
};

export const getDroplist = (id) => {
  return apiClient
    .get(`/survey-api/api/wealth/drop-list/${id}`)
    .then((response) => {
      return response.data;
    });
};
export const sendSurvey = (code, id, data) => {
  return apiClient
    .post(`/survey-api/api/feedback/${code}/${id}`, data)
    .then((response) => {
      return response.data;
    });
};
export const sendSurveyWealth = (surveyId, id, data) => {
  return apiClient
    .post(`/survey-api/api/wealth/feedback/${surveyId}/${id}`, data)
    .then((response) => {
      return response.data;
    });
};

export const getWealthResult = (id, mailing) => {
  return apiClient
    .get(`/wealth-admin/api/advisory-service/ocb/asset-config/${id}/${mailing}`)
    .then((response) => {
      return response.data;
    });
};
